<div
  class="column-container"
  [@fadeIn]="fadingIn"
  (@fadeIn.done)="fadeInDone($event.toState)"
  [@fadeOut]="fadingOut"
  (@fadeOut.done)="fadeOutDone($event.toState)"
>
  <h4 [matTooltip]="getHeaderTooltip()" matTooltipPosition="right">
    SECONDARY ARGUMENTS
  </h4>

  <div class="button-input-container">
    <div class="button-column">
      <ng-container *ngFor="let pair of argValuePairs; index as i">
        <div class="category-header" *ngIf="isFirstOfCategory(i)">
          {{ pair.arg.category.name }}
        </div>

        <commands-ui-single-secondary-arg-button
          [argValuePair]="pair"
          (activeChange)="emitArgs()"
          (repeatArg)="repeatArg(i)"
          (deleteArg)="deleteArg(i)"
        ></commands-ui-single-secondary-arg-button>
      </ng-container>
    </div>

    <div class="input-column">
      <ng-container *ngFor="let pair of argValuePairs; index as i">
        <!-- Hidden input element next to header -->
        <commands-ui-single-secondary-arg-input
          *ngIf="isFirstOfCategory(i)"
          [permaHidden]="true"
        ></commands-ui-single-secondary-arg-input>

        <commands-ui-single-secondary-arg-input
          [argValuePair]="pair"
          (valueChange)="emitArgs()"
        ></commands-ui-single-secondary-arg-input>
      </ng-container>
    </div>
  </div>
</div>
